import React, { useEffect, useState } from 'react';
import { BuyNowContainer, OfferStrip } from './styled';
import {
  fireProductActionEvent,
  getCartButton,
  goToCartForCategoryPage,
  productActionClick,
} from '../../../Utils/productAction';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import { mutate } from 'swr';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { OutofStock } from '../../Product/ProductAction/styled';

function BuyNowButton(props) {
  const {
    selectedVariant,
    isFixed,
    newProductData,
    lactoMama,
    userSelectedVariant,
    openChooseLactoMamaPopup,
    addProductToCartOnVariantClick,
    setAddProductToCartOnVariantClick,
    offerData,
    variantData,
    userType,
    handleClose,
    isVariantPopup,
  } = props;
  if (newProductData?.strikeprice) {
    newProductData.strikePrice = newProductData.strikeprice;
  }

  const productData = {
    id: selectedVariant,
  };
  const router = useRouter();
  const [cartButton, setCartButton] = useState(getCartButton(productData?.id));
  const [loaderState, setLoaderState] = useState('');
  const { data } = useGetCartData();
  const [currentOfferIndex, setCurrentOfferIndex] = useState(0);

  const showNewAddToCartButton = true;

  const addGoToCart = async () => {
    // If is LactoMama page and user has not selected any variant, then open the popup
    if (lactoMama && !userSelectedVariant) {
      openChooseLactoMamaPopup();
    } else {
      if (isVariantPopup) {
        handleClose();
      }
      if (cartButton == 1) {
        fireProductActionEvent('clicked_buy_now', newProductData);
        setLoaderState('loading');

        if (data) {
          await mutate('/api/getNewCartAmountOfUserWeb', null, false);
        }
        const apiResponse = await productActionClick(
          'cart',
          productData,
          cartButton,
        );
        if (apiResponse == true) {
          setTimeout(() => {
            setCartButton(2); //1:"ADD TO CART",2:"GO TO CART"
          }, 800);
          setLoaderState('loaded');
        } else {
          setLoaderState('');
          setCartButton(1);
        }
      } else {
        fireProductActionEvent('clicked_go_to_cart', newProductData);
        const apiResponse = await goToCartForCategoryPage(productData);
        if (apiResponse == true) {
          setLoaderState('');
        } else {
          setLoaderState('');
        }
      }
    }
  };

  useEffect(() => {
    setCartButton(
      getCartButton(lactoMama ? userSelectedVariant : productData?.id),
    );
    setLoaderState('');
  }, [router.query, lactoMama ? userSelectedVariant : selectedVariant]);

  useEffect(() => {
    if (addProductToCartOnVariantClick) {
      productActionClick('cart', { id: userSelectedVariant }, 1);
      setAddProductToCartOnVariantClick(false);
      Cookies.remove(`click_variant_${userSelectedVariant}`);
    }
  }, [addProductToCartOnVariantClick]);

  const showLoadingScreen = (loaderState, isExp) => {
    return (
      <CssLoader
        className={loaderState === 'loaded' ? 'load-complete' : ''}
        theme="#fff"
      >
        <div
          className="checkmark draw"
          style={loaderState === 'loaded' ? { display: 'block' } : {}}
        ></div>
      </CssLoader>
    );
  };

  let discountPercent = Math.floor(
    ((newProductData?.strikePrice - newProductData?.price) /
      newProductData?.strikePrice) *
      100,
  );

  useEffect(() => {
    if (offerData && offerData.length > 1) {
      const timer = setInterval(() => {
        setCurrentOfferIndex((prevIndex) =>
          prevIndex === offerData.length - 1 ? 0 : prevIndex + 1,
        );
      }, 3000);
      return () => clearInterval(timer);
    }
  }, [offerData]);

  return (
    <>
      {newProductData?.status === '4' ? (
        <OutofStock>OUT OF STOCK</OutofStock>
      ) : !isDesktopUser() && isFixed && showNewAddToCartButton ? (
        <>
          {offerData && offerData.length > 0 ? (
            <OfferStrip offers={offerData.length || 0}>
              <span className="offer-transition" key={currentOfferIndex}>
                {offerData?.[currentOfferIndex].description + ' Use code : '}
                <strong>{offerData?.[currentOfferIndex].code}</strong>
              </span>
            </OfferStrip>
          ) : null}
          <BuyNowContainer
            isFixed={isFixed}
            showNewAddToCartButton={showNewAddToCartButton}
            lactoMama={lactoMama}
            offerData={offerData}
          >
            <div className="BuyNowLactomama">
              {false ? (
                <div className="savings" onClick={openChooseLactoMamaPopup}>
                  <p className="beforeAndAfterPrices">
                    <span>{'₹' + newProductData?.price}</span>
                    {newProductData?.strikePrice ==
                    newProductData?.price ? null : (
                      <>
                        <span className="strikeprice">
                          {'₹' + newProductData?.strikePrice}
                        </span>
                      </>
                    )}
                  </p>
                  <div className="priceFlex">
                    <span className="discount">
                      {discountPercent + '% OFF'}
                    </span>
                    <p className="moreVarients">
                      {variantData?.length - 1} more variants {'>'}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="savings">
                  <p className="beforeAndAfterPrices">
                    <span>{'₹' + newProductData?.price}</span>
                    {newProductData?.strikePrice ==
                    newProductData?.price ? null : (
                      <>
                        <span className="strikeprice">
                          {'₹' + newProductData?.strikePrice}
                        </span>
                        <span className="discount">
                          {discountPercent + '% OFF'}
                        </span>
                      </>
                    )}
                  </p>
                  <div className="priceFlex">
                    <p className="inclTaxes">
                      (addl. taxes & charges applicable)
                    </p>
                  </div>
                </div>
              )}
              <button onClick={() => addGoToCart()}>
                {cartButton === 1
                  ? loaderState === 'loading' || loaderState === 'loaded'
                    ? showLoadingScreen(loaderState)
                    : 'ADD TO CART'
                  : 'GO TO CART'}
              </button>
            </div>
          </BuyNowContainer>
        </>
      ) : (
        <BuyNowContainer isFixed={isFixed} lactoMama={lactoMama}>
          <p onClick={() => addGoToCart()} suppressHydrationWarning>
            {cartButton === 1
              ? loaderState === 'loading' || loaderState === 'loaded'
                ? showLoadingScreen(loaderState)
                : 'ADD TO CART'
              : 'GO TO CART'}
          </p>
        </BuyNowContainer>
      )}
    </>
  );
}

export default BuyNowButton;
